import React, { Component } from 'react';
import { Modal, DatePicker, Select, Input, message, Radio} from 'antd';
import Text from '../../../basicElement/Text';
import $ from '../../../../common/AjaxRequest';
import { xToken } from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import moment from 'moment';

const dateFormat = "YYYY-MM-DD";
const Option = Select.Option;


class OnMarket extends Component {
    state = {
        params: {},
        visible: false,
        secondLineName:null,
        canCreat:null,
        seveParams:{},
    }

    show = ( record ) =>{
        this.queryShowData(record)
        this.setState({visible:true,record});
    }

    queryShowData = (record) =>{
        const { seveParams } = this.state;
        const {
            cdeRegisteNum,
            medicineNameCh,
            medicineNameEn,
            commodityNameCh,
            commodityNameEn,
            marketApprovalTimeStr,
            approvalTypeId,
            approvalTypeRemark,
            medicineKeyWord,
            remark
        } = record;
        seveParams.cdeRegisteNum = cdeRegisteNum || undefined;
        seveParams.medicineNameCh = medicineNameCh || undefined;
        seveParams.medicineNameEn = medicineNameEn || undefined;
        seveParams.commodityNameCh = commodityNameCh || undefined;
        seveParams.commodityNameEn = commodityNameEn || undefined;
        seveParams.marketApprovalTime = marketApprovalTimeStr || undefined;
        seveParams.approvalTypeId = approvalTypeId || undefined;
        seveParams.approvalTypeRemark = approvalTypeRemark || undefined;
        seveParams.medicineKeyWord = medicineKeyWord || undefined;
        seveParams.remark = remark || undefined;
        this.setState({seveParams})
    }

    isOk = () =>{
        const { marketApprovalTime , approvalTypeId ,approvalTypeRemark } = this.state.seveParams;
        if(!marketApprovalTime){
            message.error('请选择上市批准时间！');
            return
        }
        if(!approvalTypeId){
            message.error('请选择获批类型！');
            return
        }
        if(approvalTypeId == 6 && !approvalTypeRemark){
            message.error('请填写备注说明！');
            return
        }
        this.submit()
    }

    submit = () =>{
        const { seveParams , record } = this.state;
        const options = {
            method: 'POST',
            url: API_URL.nationalverification.saveMarketRegiste,
            data: {
                investigationId:record.investigationId,
                ...seveParams},
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.props.loadData();
                this.hide();
            },
            errorResult: err => {
                console.log(err);
            }
        };
        $.sendRequest(options);
    }

    handleDateChange = (date, dateString,key)=>{
        const { seveParams } = this.state;
        seveParams[key] = dateString;
        this.setState({seveParams})
    }

    handleChange = (value , key)=>{
        const {seveParams} = this.state;
        seveParams[key] = value;
        if(key == 'approvalTypeId' && value !== 6){
            seveParams.approvalTypeRemark = null;
        }
        this.setState({seveParams})
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    getContent = () =>{
        const { visible , seveParams , record } = this.state;
        const {approvalTypeList} = this.props
        const {
            investigationName,
            sponsorName,
            investigationMedicineType,
            investigationMedicineTypeShow,
            treatmentMethodName,
            drugMainTargets,
            investigationMedicine,
            administrationModeName,
            cdeRegisteNum
        } = record;
        const isResearch_drugs = investigationMedicineType == 'Research_drugs';          //药物
        const isTechnology = investigationMedicineType == 'Technology';                  //技术类（如细胞技术）
        const approvalTypeOption = approvalTypeList.map(i => <Option key={i.nationVerifyConfigureId} value={i.nationVerifyConfigureId}>{i.configureValue}</Option>);
        const content = (
            <div className="modal-content" style={{ padding: '0 5px' }}>
                    <ul className="modal-list">
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>项目简称: </div>
                            <div className="item-right">
                                {investigationName}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>申办方: </div>
                            <div className="item-right">
                                {sponsorName}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>研究产品类型: </div>
                            <div className="item-right">
                                {investigationMedicineTypeShow}
                            </div>
                        </li>
                        {
                            (isResearch_drugs || isTechnology)&&
                            <li className="modal-item">
                                <div className="item-left" style={{ padding: '0' }}>治疗方式: </div>
                                <div className="item-right">
                                    {treatmentMethodName }
                                </div>
                            </li>
                        }
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0'}}>药物（疗法）分类/<br/>主要作用靶点:</div>
                            <div className="item-right" style={{lineHeight: '50px'}}>
                                {drugMainTargets}
                            </div>
                        </li>
                        {
                            isResearch_drugs &&
                            <li className="modal-item">
                                <div className="item-left" style={{ padding: '0' }}>研究药物通用名称: </div>
                                <div className="item-right">
                                    {investigationMedicine}
                                </div>
                            </li>
                        }
                        {
                            isTechnology &&
                            <li className="modal-item">
                                <div className="item-left" style={{ padding: '0' }}>技术名称: </div>
                                <div className="item-right">
                                    {investigationMedicine}
                                </div>
                            </li>
                        }
                        {
                            (!isResearch_drugs && !isTechnology) &&
                            <li className="modal-item">
                                <div className="item-left" style={{ padding: '0' }}>产品具体名称: </div>
                                <div className="item-right">
                                    {investigationMedicine}
                                </div>
                            </li>
                        }
                        {
                            isResearch_drugs &&
                            <li className="modal-item">
                                <div className="item-left" style={{ padding: '0' }}>给药方式: </div>
                                <div className="item-right">
                                    {administrationModeName}
                                </div>
                            </li>
                        }
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>CDE试验公示登记号: </div>
                            <div className="item-right">
                                {cdeRegisteNum}
                            </div>
                        </li>
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>药品名（中）: </div>
                            <div >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={seveParams.medicineNameCh}
                                    onChange={e => this.handleChange(e.target.value, 'medicineNameCh')}
                                />
                            </div>
                        </li><li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>药品名（英）: </div>
                            <div >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={seveParams.medicineNameEn}
                                    onChange={e => this.handleChange(e.target.value, 'medicineNameEn')}
                                />
                            </div>
                        </li><li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>商品名（中）: </div>
                            <div >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={seveParams.commodityNameCh}
                                    onChange={e => this.handleChange(e.target.value, 'commodityNameCh')}
                                />
                            </div>
                        </li><li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>商品名（英）: </div>
                            <div >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={seveParams.commodityNameEn}
                                    onChange={e => this.handleChange(e.target.value, 'commodityNameEn')}
                                />
                            </div>
                        </li><li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>上市批准时间</Text><br/>（药监局最早发证日期为准）</div>
                            <div style={{ lineHeight: '50px' }}>
                                {
                                    seveParams.marketApprovalTime?
                                    <DatePicker
                                        placeholder="请选择"
                                        style={{ width: 260}}
                                        value={moment(seveParams.marketApprovalTime,dateFormat)}
                                        onChange={(date, dateString) => this.handleDateChange(date, dateString ,'marketApprovalTime')}
                                    />:
                                    <DatePicker
                                        placeholder="请选择"
                                        style={{ width: 260}}
                                        onChange={(date, dateString) => this.handleDateChange(date, dateString ,'marketApprovalTime')}
                                    />
                                }
                                
                            </div>
                        </li><li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>获批类型</Text> </div>
                            <div >
                                <Select
                                    allowClear={true}
                                    style={{width:'260px'}}
                                    placeholder="请选择"
                                    value={seveParams.approvalTypeId}
                                    onChange={value => this.handleChange(value, 'approvalTypeId')}
                                >
                                    {approvalTypeOption}
                                </Select>
                            </div>
                        </li>
                        {
                            seveParams.approvalTypeId == 6 &&
                            <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}><Text asterisk={true} colon={true}>备注说明</Text> </div>
                            <div >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={seveParams.approvalTypeRemark}
                                    onChange={e => this.handleChange(e.target.value, 'approvalTypeRemark')}
                                />
                            </div>
                        </li>
                        }
                        <li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>药监局关键字索引: </div>
                            <div >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={seveParams.medicineKeyWord}
                                    onChange={e => this.handleChange(e.target.value, 'medicineKeyWord')}
                                />
                            </div>
                        </li><li className="modal-item">
                            <div className="item-left" style={{ padding: '0' }}>卖点/说明（如有）: </div>
                            <div >
                                <Input
                                    placeholder="请输入"
                                    style={{ width: 260 }}
                                    value={seveParams.remark}
                                    onChange={e => this.handleChange(e.target.value, 'remark')}
                                />
                            </div>
                        </li>
                    </ul>
                </div>
        )
        return content;
    }

    render() {
        const { visible , seveParams} = this.state;
        const radioStyle = {
            display: 'block',
            height: '30px',
            lineHeight: '30px',
        };
        return (
            <Modal
                title={`上市后登记`}
                visible={visible}
                onCancel={this.hide}
                onOk={this.isOk}
                className="create-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="525px"
                bodyStyle={{maxHeight:"600px"}}
            >
                {   visible &&
                    this.getContent()
                }
            </Modal>
        )
    }
}

export default OnMarket;


// WEBPACK FOOTER //
// ./src/components/qualityManagement/ImportantMilestone/components/OnMarket.js